import { render, staticRenderFns } from "./DashboardData.vue?vue&type=template&id=49d3470d&scoped=true&"
import script from "./DashboardData.vue?vue&type=script&lang=js&"
export * from "./DashboardData.vue?vue&type=script&lang=js&"
import style0 from "./DashboardData.vue?vue&type=style&index=0&id=49d3470d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3470d",
  null
  
)

export default component.exports